// Flow types automatically removed

import { fetchQuery_DEPRECATED as fetchQuery, graphql } from 'react-relay/legacy.js';
import getter from 'dibs-object-getter';
import { logError } from '../../helpers.ts';
import { getEnvironment } from '../../relayModernEnvironment.ts';
const environment = getEnvironment();
export function userLookup(userId) {
    if (!userId) {
        return Promise.resolve({});
    }

    return fetchQuery(
        environment,
        graphql`
            query userLookupQuery($userId: String!) {
                viewer {
                    user(userId: $userId) {
                        profile {
                            email
                            firstName
                            lastName
                        }
                    }
                }
            }
        `,
        {
            userId,
        }
    )
        .then(response => getter(response).at('viewer').at('user').value('profile') || {})
        .catch(e => {
            logError(e);
            return {};
        });
}
